import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { IncepticaLogo } from "./Logos";
import { CONTACT_EMAIL, NOVA_URL, LINKEDIN_URL } from "../data/site";

const linkCls = "text-sm text-zinc-600 hover:text-zinc-900 transition-colors w-fit";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative border-t border-zinc-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <IncepticaLogo className="h-10" />
            <p className="mt-5 max-w-sm text-sm text-zinc-500 leading-relaxed">
              An enterprise AI product company. Home of Nova — our flagship
              AI-powered compliance and certification platform.
            </p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email"
              className="mt-5 inline-block text-sm text-zinc-700 hover:text-zinc-900 transition-colors"
            >
              {CONTACT_EMAIL}
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-7 flex flex-col gap-3">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-400">
              Product
            </p>
            <a
              href={NOVA_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-nova-link"
              className={`${linkCls} inline-flex items-center gap-1`}
            >
              Nova <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
            <a href="/#services" className={linkCls}>Services</a>
            <a href="/#about" className={linkCls}>About</a>
            <a href="/#contact" className={linkCls}>Contact</a>
          </div>

          <div className="md:col-span-3 flex flex-col gap-3">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-400">
              Company
            </p>
            <Link to="/privacy" data-testid="footer-privacy-link" className={linkCls}>
              Privacy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className={linkCls}>
              Terms
            </Link>
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className={`${linkCls} inline-flex items-center gap-1.5`}
            >
              <Linkedin className="w-4 h-4" /> LinkedIn
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-zinc-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} Inceptica. All rights reserved.
          </p>
          <p className="text-xs text-zinc-500">
            Building AI products that solve real business problems.
          </p>
        </div>
      </div>
    </footer>
  );
};
